export default __webpack_public_path__ + "static/media/Finance.a914722b.svg";